import { HmModelRest } from './abstract_model';

export class CategoriaFaqOperatore extends HmModelRest {
    static readonly rest_path = 'categorie_faq_operatore';

    id: number;
    nome: string;
    ispublic: boolean;

}

export class CategoriaFaqOperatorePublic extends HmModelRest {
    static readonly rest_path = 'categorie_faq_operatore/public/';

    id: number;
    nome: string;
    ispublic: boolean;
    disabled: boolean;

}


export class FaqOperatorePublic extends HmModelRest {
    static readonly rest_path = 'faq_operatore/public/';

    id: number;
    categoria: number;
    domanda: string;
    risposta: string;
    ispublic: boolean;
    disabled: boolean;

}

export class FaqOperatore extends HmModelRest {
    static readonly rest_path = 'faq_operatore';

    id: number;
    categoria: number;
    domanda: string;
    risposta: string;
    ispublic: boolean;
    disabled: boolean;

}
